module.exports = __webpack_public_path__ + "static/media/wallet.ede1d5ee.png";